import {getItemName} from "../../../shared/utils/basic";
import dayjs from "dayjs";
import {Sorter} from "../../../shared/components/Sorter";

export const getGoodsLogColumns = (krTextData, currentUser, itemType = 1) => {
    return [
        {
            title: '이벤트 Type',
            dataIndex: 'logType',
            search: true,
        },
        {
            title: '이벤트 ID',
            dataIndex: 'logValue',
            search: true,
        },
        {
            title: '아이템 ID',
            dataIndex: 'itemId',
            search: true,
        },
        {
            title: '아이템 이름',
            dataIndex: 'itemId',
            render: (_, {itemId, productId}) => getItemName(krTextData[currentUser.target], itemId, itemType, productId)
        },
        {
            title: '변화 값',
            dataIndex: 'updatedValue',
        },
        {
            title: '최종 값',
            dataIndex: 'lastValue',
        },
        {
            title: '날짜',
            dataIndex: 'created',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.time, b.time),
        },
    ]
};